<script setup lang="ts">
import type {Populated} from '~/types/populated'
import type {AboutUs} from '~/types/legacy'

const props = defineProps<{
  headline: string
  imageGrid: Populated<AboutUs>['imageGrid']
}>()

const pixelGridLg = [
  '                                    ',
  '  1111111111111111111111111111111111111   ',
  ' 1111111111111111111111121111111111111    ',
  '  1111111112211111111122121111111111111   ',
  '   111111111111      1111111111111111111  ',
  '   1111111111111       111111122111111111 ',
  '   11111111111111111    T111111111111111  ',
].join('\n')
</script>

<template>
  <Container
    class="screen-content pointer-events-none relative z-0 flex flex-col items-center space-y-6 pb-16 pt-32 md:pb-16 lg:pb-16 lg:pt-48"
  >
    <div class="relative z-10 -mt-8 h-full w-full lg:-mt-16">
      <Motion :animate="{y: 0, opacity: 1}" :initial="{y: -16, opacity: 0}" :transition="{ease: [0.16, 1, 0.3, 1]}">
        <Heading size="hero" as="h1" class="pointer-events-none text-center" gradient="gray">
          {{ headline }}
        </Heading>
      </Motion>

      <AboutUsImageGrid v-if="imageGrid?.length" :data="imageGrid" class="pointer-events-auto relative z-10 mt-16" />
    </div>

    <div class="pointer-events-auto absolute inset-0 -z-10 h-full w-full px-4 md:px-8">
      <PixelGrid class="h-full" :pattern="pixelGridLg" />
    </div>
  </Container>
</template>
